const DEFAULT_SLUG = 'danh-muc';

export function slugifyCategoryName(value: string | undefined | null): string {
  if (!value?.trim()) {
    return DEFAULT_SLUG;
  }
  const normalized = value
    .replace(/\u0111/g, 'd')
    .replace(/\u0110/g, 'D')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
  return normalized || DEFAULT_SLUG;
}
